export function EmailContactsListingRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailContactsListing', {
		url: '/admin/contacts',
		controllerAs: 'vm',
		controller: EmailContactsListingCtrl,
		permission: ['manage_users'],
		templateUrl: '/ng/hub/Email/Contacts/Listing/EmailContactsListingCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'Manage Email Contacts',
		},
	});
}

export class EmailContactsListingCtrl {
	constructor($location, $timeout, $filter, notifications, modal) {
		'ngInject';
		// save injections
		this.$location = $location;
		this.$timeout = $timeout;
		this.notifications = notifications;
		this.modal = modal;

		// set up data table
		this.filters = { role: 'observer' };
		this.columns = [
			{ field: 'email', label: 'Email', sortable: true },
			{ field: 'fname', label: 'First Name', sortable: true },
			{ field: 'lname', label: 'Last Name', sortable: true },
			{ field: 'fname_preferred', label: 'Preferred First Name', sortable: true },
			{ field: 'lname_preferred', label: 'Preferred Last Name', sortable: true },
			{ field: 'created_at', label: 'Created', sortable: true },
		];
		this.actions = [{ label: 'Edit', icon: null, callback: this.editContact.bind(this) }];
		this.limit = 10;
		const dateFormat = $filter('shDate');
		this.transformer = records => {
			records.data.forEach(user => {
				user.created_at = dateFormat(user.created_at, 'long');
			});
			return records;
		};
	}

	$onInit() {
		const { message } = this.$location.search();

		if (message) {
			// $timeout makes angular and the external library play nice
			this.$timeout(() => this.notifications.showSuccess({ message, hideDelay: 2000 }));
		}
	}

	editContact(user) {
		window.location.href = `/hub#/admin/users/${user.id}/edit`;
	}

	importContacts() {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.UserImport', {
				params: { onlyContacts: true },
				heading: `Import Contacts`,
				height: 550,
				width: 750,
			})
			.then(reload, reload);
	}

	addContact() {
		// TODO: edit in modal
		window.location.href = `${window.BASE_URL}/core/admin/contacts/add`;
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}
}
